/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeetingRequestDto
 */
export interface MeetingRequestDto {
    /**
     * Meeting creator user id
     * @type {string}
     * @memberof MeetingRequestDto
     */
    creatorId: string;
    /**
     * Meeting title
     * @type {string}
     * @memberof MeetingRequestDto
     */
    title: string;
    /**
     * Start time of the meeting
     * @type {string}
     * @memberof MeetingRequestDto
     */
    startTime: string;
    /**
     * End time of the meeting
     * @type {string}
     * @memberof MeetingRequestDto
     */
    endTime: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingRequestDto
     */
    participants?: Array<string>;
    /**
     * Meeting Id in third-party calendar
     * @type {string}
     * @memberof MeetingRequestDto
     */
    externalId?: string;
}

/**
 * Check if a given object implements the MeetingRequestDto interface.
 */
export function instanceOfMeetingRequestDto(value: object): boolean {
    if (!('creatorId' in value)) return false;
    if (!('title' in value)) return false;
    if (!('startTime' in value)) return false;
    if (!('endTime' in value)) return false;
    return true;
}

export function MeetingRequestDtoFromJSON(json: any): MeetingRequestDto {
    return MeetingRequestDtoFromJSONTyped(json, false);
}

export function MeetingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeetingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'creatorId': json['creatorId'],
        'title': json['title'],
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'participants': json['participants'] == null ? undefined : json['participants'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function MeetingRequestDtoToJSON(value?: MeetingRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'creatorId': value['creatorId'],
        'title': value['title'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'participants': value['participants'],
        'externalId': value['externalId'],
    };
}

